var map = {
	"./accessible-three-scene-placeholder.jpg": 118,
	"./accessible-three-scene.mp4": 119,
	"./observer-api-for-modern-javascript-placeholder.jpg": 120,
	"./observer-api-for-modern-javascript.jpg": 121,
	"./windows-settings.jpg": 122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;